import { render, staticRenderFns } from "./targetcollection.vue?vue&type=template&id=8ac209b0&scoped=true"
import script from "./targetcollection.vue?vue&type=script&lang=js"
export * from "./targetcollection.vue?vue&type=script&lang=js"
import style0 from "./targetcollection.vue?vue&type=style&index=0&id=8ac209b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac209b0",
  null
  
)

export default component.exports